export default __webpack_public_path__ + "static/media/yt_nibiru-ep6.23bf9adc.jpg";